import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationCaosConfiguration } from "@/model/data/caosConfiguration/InstallationCaosConfiguration";

export class FetchInstallationCaosConfigurationResData extends ApiGenericResponse {
    installationsList: InstallationCaosConfiguration[];
    totalInstallationsCount: number;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsList) {
            this.installationsList = new Array<InstallationCaosConfiguration>();
            obj.InstallationsList.forEach((element) => {
                let c = new InstallationCaosConfiguration();
                c.parse(element);
                this.installationsList.push(c);
            });
        }

        if (obj.TotalInstallationsCount != null && obj.TotalInstallationsCount != undefined) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
